// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__rlBrb","filesListContainer":"PosDisputesFiles_filesListContainer__dnSE1","filesButton":"PosDisputesFiles_filesButton__y6p9C"};